module.exports = __webpack_public_path__ + "static/img/shop_avatar.305df81a.png";